import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { StoresApi } from "apis/StoresApi";
import { StoreExtended } from "models/dbModels/stores/Store";
import { StoreSearchFilterQuery } from "models/filters/stores/StoreSearchFilterQuery";

export const getFunctionStores = createAsyncThunk( "functionSlice/getFunctionStores", async (params: StoreSearchFilterQuery) => {
  const response = await StoresApi.Search(params);
    return response.data;
  }
);

type InitialStateType = {
  functionStores: StoreExtended[];
};

const initialState: InitialStateType = {
  functionStores: [],
};

const functionSlice = createSlice({
  name: "functionSlice",
  initialState: {
    ...initialState,
  },
  reducers: {
  },
  extraReducers(builder) {
    builder.addCase(getFunctionStores.pending, (state) => {
        state.functionStores = [];
    });
    builder.addCase(getFunctionStores.fulfilled, (state, action) => {
        state.functionStores = action.payload.data;
    });
  },
});

// export const {  } = functionSlice.actions

export default functionSlice.reducer;